import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: theme.shape.borderRadius * 2,
      padding: theme.spacing(1),
    },
  },
  dialogTitle: {
    padding: theme.spacing(2, 3, 1),
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  dialogContent: {
    padding: theme.spacing(1, 3, 2),
  },
  sectionLabel: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  sectionBox: {
    marginBottom: theme.spacing(2.5),
  },
  radioGroup: {
    gap: theme.spacing(0.5),
  },
  formControlLabel: {
    marginLeft: 0,
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
      color: theme.palette.text.primary,
    },
  },
  formatRow: {
    display: 'flex',
    gap: theme.spacing(3),
  },
  emailField: {
    '& .MuiOutlinedInput-input': {
      fontSize: 14,
    },
  },
  emailHint: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  dialogActions: {
    padding: theme.spacing(1, 3, 2),
    gap: theme.spacing(1),
  },
  cancelButton: {
    textTransform: 'none',
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  generateButton: {
    textTransform: 'none',
    fontWeight: 700,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}))

export default useStyles
